import store from "../store";
import { SEARCH_UPDATE } from "../store/slices";
import { DatabaseInstance } from "./databaseClass";

class SearchClass {
  private getState() {
    return store.getState().search;
  }

  constructor() {}

  // this function will be called when the user clicks on the search button
  public setSearchType(
    searchType: "brand" | "product" | "all" | "venue" | "current-customer" | "add-customer",
    handler: Function,
  ): this {
    // Reset search results when changing the type
    store.dispatch(
      SEARCH_UPDATE({
        data: {
          search: "",
          searchType: searchType,
          searchResults: [],
        },
      }),
    );

    handler("");
    console.log("search type:", this.getState().searchType);

    return this;
  }

  // this function will be called when the user starts typing in the search bar
  public setSearchQuery(search: string): this {
    // set the search query in the store
    store.dispatch(
      SEARCH_UPDATE({
        data: {
          search: search,
          searchType: this.getState().searchType,
          searchResults: this.getState().searchResults,
        },
      }),
    );

    console.log("search query:", this.getState().search);

    this.performSearch();
    return this;
  }

  public async performSearch() {
    try {
      let endpoint = "";
      if (this.getState().searchType === "brand") {
        endpoint = "search/brands?name=" + this.getState().search;
      } else if (this.getState().searchType === "product") {
        endpoint = "search/products?searchTerm=" + this.getState().search;
      } else if (this.getState().searchType === "current-customer") {
        endpoint = "admin/search-customers?current=true&searchTerm=" + this.getState().search;
      } else if (this.getState().searchType === "add-customer") {
        endpoint = "admin/search-customers?current=false&searchTerm=" + this.getState().search;
      } else {
        // logic for 'all' or default search type if necessary
        endpoint = "search/brands-and-products?searchTerm=" + this.getState().search;
      }

      const data = {
        endpoint,
      };

      console.log("getting search results iwth data:", data);

      const res = await DatabaseInstance.getRecord(data);

      console.log("search results:", res);

      store.dispatch(
        SEARCH_UPDATE({
          data: {
            search: this.getState().search,
            searchType: this.getState().searchType,
            searchResults: res,
          },
        }),
      );
    } catch (error) {
      console.error("Search error:", error);
    }
  }

  // public filterSearchResults(searchResults: any[], filterResults: any[]): any[] {

  //     const filterNames = filterResults.map(item => item.name);

  //     const filteredResults = searchResults.filter(result => !filterNames.includes(result.name));

  //     return filteredResults;
  // }
}

const SearchInstance = new SearchClass();
export { SearchInstance };
